export default {
    trim: function (str) {
        const reSpace = /^\s+|\s+$/;
        return str.replace(reSpace, '');
    },
    //key转小写。实现$route.query参数不区分大小写
    lowerObj(obj) {
        var ret = {}
        Object.keys(obj).map(key => {
            ret[key] = obj[key]
            ret[key.toLowerCase()] = obj[key]
        })
        return ret
    },
    locationReplace(url) {
        try {
            location.replace(url);
        } catch (e) {
            if (history.replaceState) {
                history.replaceState(null, document.title, url);
                history.go(0);
            } else {
                location = url
            }
        }
    }
}
